(function ($) {
    $('body')
        .on('show.bs.modal', '.modal', onModalShow)
        .on('hide.bs.modal', onModalHide);
            var focusElement;
            var ytApiLoaded = false;
            function loadYouTubeAPI() {
            if (ytApiLoaded) return;
            ytApiLoaded = true;
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
  
    // Append params like enablejsapi=1
    function appendIframeParams(ytIframe) {
        if (!ytIframe) return;
    
        const iframe = $(ytIframe);
        let src = iframe.attr('src');
    
        const params = [
            { param: 'enablejsapi', value: '1' },
            { param: 'rel', value: '0' },
            { param: 'modestbranding', value: '1' }
        ];
    
        const url = new URL(src, window.location.origin);
        const searchParams = url.searchParams;
    
        for (const { param, value } of params) {
            if (!searchParams.has(param)) {
                searchParams.set(param, value);
            }
        }
    
        url.search = searchParams.toString();
        iframe.attr('src', url.toString());
    }
    

    //  For Brightcove video
            // Check if videojs is loaded     
            function waitForBrightcove(callback) {
                if (typeof videojs !== "undefined") {
                    callback();
                } else {
                    setTimeout(function () {
                        waitForBrightcove(callback);
                    }, 500);
                }
            }
  
    // Global array to keep track of player instances if needed
   const ytPlayers = new Map();
   
            function onModalShow(e) {
                    $(".body-wrapper").attr("aria-hidden", "true");
                    focusElement = document.activeElement;
                    var modal = $(e.target);
                    const modalId = modal.attr("id");
                    console.log("Modal ID:", modalId);
                    const $ctaBtn = $(`[data-bs-target="#${modalId}"]`).first();
                    console.log("CTA Button:", $ctaBtn);
                    const parentComponent = $ctaBtn.closest('.color-card-layout');
                
           
                    if ($ctaBtn.length === 0) {
                        console.warn("No CTA found for modal:", modalId);
                        return;
                    }

                    for (var i = 0; i < $('.modal.fade').length; i++) {
                        if (focusElement.dataset.target !== modal.attr('id')) {
                            var ele = $('.modal.fade')[i];
                            ele.setAttribute("aria-hidden", "true");
                        } else {
                            var ele1 = $('.modal.fade.show')[i];
                            ele1.setAttribute("aria-hidden", "false");
                        }
                    }
            
                    if (!modal.is('[data-suppress-move="true"]')) {
                        ensureModalIsFormChild(modal);
                    }
                    if (parentComponent.length === 0) {
                        return; // Not a secnav video, don't bind anything here!
                     }
            
                /* For Youtube video */
                if (parentComponent.length > 0) {
                    
                const ytIframe = modal.find('iframe[src*="youtube"]')[0];
            
                if (ytIframe) {
                    appendIframeParams(ytIframe);
                    const iframeId = ytIframe.id || `yt-iframe-${Date.now()}`;
                    ytIframe.id = iframeId; // ensure it has an ID
            
                    function createYTPlayerWhenReady() {
                    const player = new YT.Player(ytIframe, {
                        events: {
                        'onStateChange': function (event) {
                            if (event.data === YT.PlayerState.PLAYING) {
                            console.log("YouTube video play detected.");
                            trackAnalytics($(ytIframe), player);
                            }
                        }
                        }
                    });
            
                    ytPlayers.set(iframeId, player);
                    }
            
                    // If API already loaded
                    if (window.YT && window.YT.Player) {
                    createYTPlayerWhenReady();
                    } else {
                    // If API not ready, queue it
                    window.onYouTubeIframeAPIReady = function () {
                        createYTPlayerWhenReady();
                    };
                    }
            
                    loadYouTubeAPI(); // Load the script only once
                }
                 /* For Youtube video */
                 /* For Brightcove video */
                waitForBrightcove(initVideoEvents);
                function initVideoEvents() {
                    modal.find(".video-js").each(function () {
                        console.log("it is inside video");
                        var videoElem = this;
                        if (!$(videoElem).data("initialized")) {
                            var bcPlayer = videojs(videoElem);
                            var videoId = $(videoElem).attr("data-video-id") || "video-" + Math.random();
            
                            $(videoElem).data("initialized", true);
            
                            bcPlayer.ready(function () {
                                //  console.log("Brightcove Video Duration Found:", videoDurations[videoId]);
                                bindPlayerEvents(bcPlayer, videoId);
                            });
                        }
                    });
                }

                function bindPlayerEvents(player, videoId) {

                    console.log("bindPlayerEvents");

                    player.ready(function () {
                        // console.log("Player " + videoId + " is ready, binding events...");
            
                        player.on("play", function () {
                            //  console.log("Video " + videoId + " playing, pausing other videos...");
                            trackAnalytics(player, videoId);
                            // Pause carousel if the video is inside one
                        });
                    })
                }
             /* For Brightcove video */
                function trackAnalytics() {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "componentInteraction",
                        componentType: "colorCards",
                        interactionType: "videoPlay",
                        elementClicked: "video",
                        contentTitle: contentTitle($ctaBtn),
                        destinationURL: "",
                        deviceType: getDeviceType()
                    });
                    console.log('Tracked YouTube videoPlay event');
                }
            }
        }

        function contentTitle($ctaBtn) {
            const header = $ctaBtn.closest(".card-content-color-card")
            .find(".card-header-color-card")
            .find("h1, h2, h3, h4, h5, h6")
            .text();
            return header.trim();
        }
    function getDeviceType() {
        const userAgent = navigator.userAgent;
        const width = window.innerWidth;
    
        if(/Tablet|iPad/i.test(userAgent) || (width > 768 && width <= 1024)) {
            return "tablet";
        } else if (/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i.test(userAgent)) {
            return "mobile";
        } else {
            return "desktop";
        }
    
    }

    function onModalHide(e) {
        if (!$(document.activeElement).parents().hasClass('modal-dialog')) {
            attachEventHandler("modalOutsideClick", "backdropClick", true);
        }
        $(".body-wrapper").attr("aria-hidden", "false");
        for (var i = 0; i < $('.modal.fade').length; i++) {
            var ele = $('.modal.fade')[i];
            ele.setAttribute("aria-hidden", "false");
        }
        setTimeout(function () { focusElement.focus(); }, 1000);
        var iframeSrc = $(e.target).siblings();
        var iframeEle = $(iframeSrc).children('iframe');
        if ($(iframeEle).attr('allow') === 'autoplay') {
            $(iframeEle).attr('src', '');
        } else {
            $(iframeEle).attr('src', $(iframeSrc).children('iframe').attr('src'));
        }
    }


    function ensureModalIsFormChild(modal) {
        if (!modal.parent().is('body')) modal.appendTo('body');
    }

}(window.jQuery));
analytics.eventConfig.push({
    "target": ".color-cards",
    "events": [ 
        {
            "eventTarget": ".heading-align-color-cards .heading-section a",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked': "link",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".card-body-color-card .cta-button a.button-primary",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked': "button",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".card-body-color-card .cta-button a.button-secondary",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked': "button",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".card-body-color-card .cta-button a.button-secondary-white",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked': "button",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".card-body-color-card .cta-button-popup-modal a.button-primary",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked': "button",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".card-body-color-card .cta-button-popup-modal a.button-secondary",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked': "button",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".card-body-color-card .cta-button-popup-modal a.button-secondary-white",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked': "button",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".card-body-color-card .cta-button a.button-tertiary",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked': "link",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },

        {
            "eventTarget": ".card-body-color-card .cta-button-popup-modal a.button-tertiary",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'colorCards',
                'interactionType': 'click',
                'elementClicked':  "link",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        }

    ]

});